import type { PopupInterface } from '~~/server/types/popup'
import { usePopups } from '~/composables/usePopups'

export default defineNuxtPlugin((nuxtApp) => {
  const enteredAt = Date.now()
  const { start } = usePopups()

  onNuxtReady(() => {
    void nuxtApp.$api<PopupInterface[]>('popups', { method: 'GET' })
      .then((popups) => start(popups ?? [], enteredAt))
      .catch((error) => console.error('Popup loading failed:', error))
  })
})
